import React from 'react';
import { useLoading } from '../context/LoadingContext';
import { useLanguage } from '../context/LanguageContext';
import '../styles/GlobalLoading.css';

export default function GlobalLoading() {
  const { isLoading, loadingMessage } = useLoading();
  const { language } = useLanguage();

  if (!isLoading) return null;

  const defaultMessage = language === 'cn' ? 'Loading...' : '加载中...';
  const displayMessage = loadingMessage || defaultMessage;

  return (
    <div className="global-loading-overlay">
      <div className="global-loading-container">
        <div className="global-loading-spinner"></div>
        <p className="global-loading-text">{displayMessage}</p>
      </div>
    </div>
  );
}